import request from '../../utils/request';
import {baseDomain} from '../baseDomain'

// 查询联系方式
export const selectPartList = query => {
    return request({
        url: `${baseDomain}/uccn/part/selectPartList`,
        method: 'post',
        data: query
    });
};
